import React from 'react'

import BidsCarousel from '../../components/carousel/bidsCarousel'
import { HeadLine } from '../../components/component'

const More_items = () => {
  return (
    <section className="dark:bg-jacarta-800 bg-light-base py-24">
      {/* <!-- Hot Bids --> */}
      <div className="container">
        <HeadLine
          text="その他のアイテム"
          classes="font-display text-jacarta-700 mb-8 text-center text-3xl font-bold dark:text-white"
        />

        <div className="relative">
          {/* <!-- Slider --> */}
          <BidsCarousel />
        </div>
      </div>
      {/* <!-- end hot bids --> */}
    </section>
  )
}

export default More_items
